import { render, staticRenderFns } from "./SamH2.vue?vue&type=template&id=16c64adc&scoped=true&"
import script from "./SamH2.vue?vue&type=script&lang=js&"
export * from "./SamH2.vue?vue&type=script&lang=js&"
import style0 from "./SamH2.vue?vue&type=style&index=0&id=16c64adc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c64adc",
  null
  
)

export default component.exports